var render = function render(){var _vm=this,_c=_vm._self._c;return _c('defaultSec',[_c('materialDetail',{ref:"materialDetail"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }